"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RespondentAttributeValueSource = void 0;
var RespondentAttributeValueSource;
(function (RespondentAttributeValueSource) {
    RespondentAttributeValueSource["THIRD_PARTY"] = "third_party";
    RespondentAttributeValueSource["USER_REPORTED"] = "user_reported";
    RespondentAttributeValueSource["PUBLISHER_REPORTED"] = "publisher_reported";
})(RespondentAttributeValueSource || (exports.RespondentAttributeValueSource = RespondentAttributeValueSource = {}));
